export const SET_CUSTOMER = 'SET_CUSTOMER';
export const SET_CART = 'SET_CART';
export const PUSH_CART = 'PUSH_CART';
export const SET_CURRENT_ITEM_QTY = 'SET_CURRENT_ITEM_QTY';
export const SET_CART_SUCCESS = 'SET_CART_SUCCESS';